"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unwrapState = exports.makeError = exports.makeValue = void 0;
const makeValueObject = (kind, value, variables) => ({ kind, value, variables });
const makeValue = (value, variables) => makeValueObject('value', value, variables);
exports.makeValue = makeValue;
const makeError = (value) => makeValueObject('error', value);
exports.makeError = makeError;
function unwrapState(state) {
    return Object.fromEntries(Object.entries(state)
        .map(([key, value]) => { var _a; return [key, (_a = value === null || value === void 0 ? void 0 : value.value) !== null && _a !== void 0 ? _a : value]; }));
}
exports.unwrapState = unwrapState;
